import styled from "styled-components";

const breakpoints = {
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
};

export const ContainerAuthenticationScreen = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;
  margin: 0;
  padding: 16px;

  @media (min-width: ${breakpoints.md}) {
    padding: 20px;
  }

  @media (min-width: ${breakpoints.lg}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
`;

export const ContainerImage = styled.div`
  width: 100%;
  height: 32vh;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 576px) {
    display: none;
  }

  img {
    width: 100%;
    height: 100%;
    background-color: #002e7dff;
    mix-blend-mode: multiply;
    object-fit: cover;
  }

  @media (min-width: ${breakpoints.md}) {
    height: 40vh;
  }

  @media (min-width: ${breakpoints.lg}) {
    width: 45vw;
    height: 100vh;
  }
`;

export const ContainerInfo = styled.div`
  width: 100%;
  min-height: calc(100vh - 32vh);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  padding: 20px;

  @media (min-width: ${breakpoints.md}) {
    gap: 18px;
    padding: 24px;
    min-height: calc(100vh - 40vh);
  }

  @media (min-width: ${breakpoints.lg}) {
    width: 55vw;
    height: 100vh;
    gap: 20px;
    padding: 0;
  }
`;

export const LogoMolicar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 64px;

    @media (min-width: ${breakpoints.md}) {
      width: 72px;
    }

    @media (min-width: ${breakpoints.lg}) {
      width: 80px;
    }
  }
`;

export const Title = styled.div`
  font-family: ${(props) => props.theme.fontFamily.Montserrat};
  font-size: 20px;
  font-weight: 700;
  color: #1e3f74;
  line-height: 24px;
  text-align: center;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 22px;
  }

  @media (min-width: ${breakpoints.md}) {
    font-size: 24px;
  }
`;

export const FormColumn = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0 auto;

  @media (min-width: 992px) {
    margin: 0;
  }
`;

export const MessageLogin = styled.div`
  font-family: ${(props) => props.theme.fontFamily.Montserrat};
  font-size: 16px;
  font-weight: 700;
  color: #313333;
  line-height: 22px;

  align-self: stretch;
  text-align: left;

  margin-top: 8px;
  padding-right: 0;

  @media (min-width: 930px) {
    margin-top: 12px;
  }
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;

export const InputWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid #e6e9ee;
  border-radius: 10px;
  background: #ffffff;
  box-sizing: border-box;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;

  &:focus-within {
    border-color: #1e3f74;
    box-shadow: 0 4px 16px rgba(30, 63, 116, 0.08);
  }
`;

export const InputField = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 12px 20px;
  font-family: ${(props) => props.theme.fontFamily.Montserrat};
  font-size: 15px;
  color: #313333;
  background: transparent;
`;

export const ButtonLogin = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 28px;
  background: #1e3f74;
  color: #ffffff;
  border: none;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.03);
  transition: transform 0.12s ease, box-shadow 0.12s ease;

  &:active {
    transform: translateY(1px);
  }
`;
